import lib from '../../images/lib.jpg';
import grab from '../../images/lib_2.jpg';

export const homeObjTwo = {
  id: 'examples',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: '',
  headline: '',
  description: '',
  buttonLabel: '',
  imgStart: true,
  img: grab,
  alt: 'discussion',
  dark: false,
  primary: false,
  darkText: true,
  linkString: '/'
};

